import { NoteBlock } from "../block";

export interface HttpHookBlock extends NoteBlock {
  type: "omega/query-omega/page/block/http-hook/HttpHookBlock";
  "hook-id": string;
}

export const isHttpHookBlock = (block: NoteBlock): block is HttpHookBlock => {
  return (block as HttpHookBlock)["hook-id"] !== undefined;
};
